<template>
  <el-dialog
    :title="$l('btn_add_plan') || '添加翻单需求'"
    :visible.sync="visible"
    v-if="visible"
    width="1200px"
    top="10px"
    :show-close="true"
    :before-close="close"
    :close-on-click-modal="false"
    v-el-dialog-drag
    :modal="false"
  >
    <el-form ref="form" direction="vertical" :model="form" :rules="rules">
      <el-row :gutter="20" style="margin-top: 10px;">
        <el-col :span="24">
          <ChooseAmzSpu
            ref="chooseAmzSpu"
            :orderType="form.skuSalesChannel"
            :showOrderType="true"
            @checkboxChange="(data) => (checkboxChange = data)"
            @close="close"
            @save="save"
          ></ChooseAmzSpu>
        </el-col>
      </el-row>
    </el-form>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import EditLoading from '@/mixins/edit-loading'
import ChooseAmzSpu from '../choose-amz-spu'
import dayjs from '@/libs/util.date'

export default {
  mixins: [EditLoading],
  components: { ChooseAmzSpu },
  props: {
    visible: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    amzFlipOrderCode: { type: String, default: '' },
  },
  computed: {
    ...mapState('admin/user', ['info']),
  },
  watch: {
    info: {
      handler(userInfo) {
        if (!userInfo || userInfo === {}) return
        const { userCode, userName, userNameEn } = userInfo
        this.form.operateCode = this.form.operateCode || ''
        if (userCode && !this.form.operateCode != userCode && !this.disabled) {
          this.form.operateCode = userCode
          this.form.operateName = `${userNameEn}-${userName}`
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.init()
  },
  data() {
    return {
      form: {
        operateCode: '',
        operateName: '',
        title: '',
        skuSalesChannel: '',
      },
      checkboxChange: 0,
      nowFormat: dayjs().format('YYMMDD'),
      skuSalesChannelParams: { dictType: 'skuSalesChannel' },
      rules: {
        skuSalesChannel: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  methods: {
    init() {
      if (this.amzFlipOrderCode) {
        this.$api
          .ecomAmzFlipOrderDetailApi({
            amzFlipOrderCode: this.amzFlipOrderCode,
          })
          .then((res) => {
            this.form = { ...res.body }
          })
      }
    },
    close() {
      this.$emit('close')
    },
    async save() {
      const result = this.$refs.chooseAmzSpu.getSkuSalesChannel()
      const skuSalesChannelText = this.$refs.chooseAmzSpu.getSkuSalesChannelText()
      this.form.skuSalesChannel = result
      const spuList = this.$refs.chooseAmzSpu.getCheckedRow() || []
      if (!result) {
        this.$alert(
          this.$l('tips_select_flip_order_type_data') || '请选择翻单类型',
          this.$l('INDEX.label_completeDesc') || '确认信息',
          {
            confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
            type: 'error',
            callback: () => {},
          }
        )
        return
      } else {
        this.$confirm(
          `当前选择的翻单类型为[ ${skuSalesChannelText} ], 是否保存`,
          this.$l('INDEX.label_completeDesc') || '确认信息',
          {
            confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
            cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
            type: 'warning',
          }
        )
          .then(async () => {
            if (this.loadingOpen()) return
            const spuCodeList = spuList.map((e) => e.amzSpuCode)
            try {
              const res = await this.$api.ecomAmzFlipOrderSaveApi({
                ...this.form,
                spuCodeList,
              })
              this.loadingClose()
              if (!res) return
              this.$message({
                showClose: true,
                message: this.$l('INDEX.tips_save_ok') || res.msg,
                type: 'success',
              })
              this.close()
              const { amzFlipOrderCode = '', amzFlipOrderNo = '' } = res.body
              this.$emit('openEditPage', {
                pageType: 'editDetail',
                data: { amzFlipOrderCode, amzFlipOrderNo },
              })
            } catch (error) {
              this.loadingClose()
            }
          })
          .catch(() => {})
      }
    },
  },
}
</script>

<style></style>
